import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "titlePages" }

import { ref, onMounted, Ref } from 'vue';

/********************************
 ********** COMPONENTES *********
 *******************************/
import LTECard from '@/components/SmartLink/server - lte/LTECard.vue';

/********************************
 ************ AXIOS *************
 *******************************/
import axios                from 'axios';

/********************************
 ************ STORE *************
 *******************************/
import store                from '@/store'

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
import { STRING_GENERAL, TOKEN } from '@/constants/labels';
import { TIMEOUTTIME } from '@/constants/apis';
import CONSTAPIS from '@/constants/apis';

/********************************
 ********* INTERFACES ***********
 *******************************/
import { LTE_OBJ } from "@/interfaces/SmartLink/LTE";
import { IP_EQUIPAMENT } from "@/interfaces/SmartLink/Equips";
import { IMGS } from "@/interfaces/SmartLink/Imgs";
import { EQUIPOS, LTE_GRAPHS } from '@/interfaces/SmartLink/Equipos';

/********************************
 ********** FUNCTIONS ***********
 *******************************/
import { showConsoleError } from '@/functions/errors';

/**
 * Lista de IP de los equipos de tipo SERVIDOR/SERVER
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'ServerView',
  setup(__props) {

const  { t } = useI18n();

/********************************
 ********** CONSTANTES **********
 *******************************/
const allIPServer:Ref<string[]>     = ref([]);

/**
 * Lista de la información de los equipos SERVER
 */
const arrayServer:Ref<LTE_OBJ[]>    = ref([]);

/**
 * Muestra un error si hay una respuesta negativa de las APIS o retorne una lista vacía (No encontró valores en la DB)
 */
const showError                     = ref(false); 

/**
 * Muestra la información si hay una respuesta positiva de las APIS
 */
const showServer                    = ref(false); 

/**
 * Constante para obtener el ícono dependiendo del tipo
 */
const CONST_ICON:IMGS = {
    vmnic0      : 'mdi-network-outline',
    vmnic1      : 'mdi-network-outline',
    vmnic2      : 'mdi-network-outline',
    vmnic3      : 'mdi-network-outline',
    Link        : 'mdi-router-network', 
    vSwitch0    : 'mdi-router-network',
    vSwitch1    : 'mdi-router-network',
    vSwitch2    : 'mdi-router-network',
    vSwitch3    : 'mdi-router-network',
    vSwitch4    : 'mdi-router-network',
    vmk0        : 'mdi-dock-window',
    vmk1        : 'mdi-dock-window',
    
}

/**
 * Recorre el array de IPS que tiene la variable "allIPServer"
 * para garantizar que son IPs de TIPO SERVER/SERVIDOR.
 * Captura los valores de la API "getAllServerData"
 * Pasando como parámetro el valor de la IP
 * - Si encuentra valor, realiza toda la lógica
 * - Si no encuentra valor, elimina esa IP del array y vuelve a hacer 
 * el pedido a la API con la nueva IP.
 * 
 * Se hará así hasta encontrar algun valor o recorrer todo el array de IPs
 */
async function getAllServerData() {
    showError.value     = false;
    showServer.value    = true;

    if(allIPServer.value.length > 0){
        await axios.get(CONSTAPIS.APIS.value.server.getAllServData,{params:{ip:allIPServer.value, timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`}}}).then((res) =>{
            const allInfo = res.data;
            if(allInfo.length > 0){
                allInfo.forEach((item:EQUIPOS) => {
                    let objSERVER:LTE_OBJ = {
                        ip          :item.ip??'',
                        name        :item.name??'',
                        uptime      :'',
                        dataTable   :[],
                        statusRow   :[],
                    }
                    
                    // Convierte a JSON la variable "info_snmp"
                    let finalJSON = JSON.parse(item.info_snmp??'{}');

                    // Si el JSON tiene una llave "index", el objeto final será ese. 
                    // De caso contrario, capturará todos los valores del objeto y ese será el objeto final
                    // Se realizó esto por la combinación de valores que tiene info_snmp
                    let finalInfo = finalJSON.index ? finalJSON.index : Object.values(finalJSON);

                    finalInfo.forEach((info:LTE_GRAPHS) => {
                        if(info.ifDescr){
                            objSERVER.uptime    = finalJSON.index ? finalJSON.sysUpTime[0] : 'today';                        
                            let nameIcon        = info.ifDescr ? info.ifDescr.split("\"")[1] : '';
                           
                            objSERVER.dataTable.push({
                                    descrip         :nameIcon,
                                    fecha           :item.fecha??'',
                                    ifInUcastPkts   :(parseInt(info.ifInUcastPkts)/(1000*1000)).toFixed(2),
                                    ifMtu           :parseInt(info.ifMtu),
                                    ifOutUcastPkts  :(parseInt(info.ifOutUcastPkts)/(1000*1000)).toFixed(2),
                                    ifSpeed         :(parseInt(info.ifSpeed)/(1024*1024)).toFixed(2),
                                });
                            objSERVER.statusRow.push(
                                {title: nameIcon.split(' ')[1], status:parseInt(info.ifOperStatus),icon: CONST_ICON[nameIcon]??'mdi-ethernet'}
                            )
                        }
                    })
                    arrayServer.value.push(objSERVER) 
                })
                
                store.commit('showOverlay',false);                
                showServer.value    = true;
                showError.value     = false;
            }else{
                showError.value     = true;
                store.commit('showOverlay',false);
            }
            
        })
        .catch(function (error) {
            showServer.value    = false;
            showError.value     = true;
            showConsoleError(error);
        });
    }             
}

/**
 * Consulta la API: "getIPServer"
 * Captura las IPs de los equipos de TIPO: SERVIDOR/SERVER
 * lo almacena en el ARRAY: "allIPServer"
 */
async function getIP() {
    await axios.get(CONSTAPIS.APIS.value.server.getIPServer, { timeout : TIMEOUTTIME, headers: { "Authorization": `Bearer ${TOKEN}`} }).then((response) =>{
        if(response.data.length === 0){
            store.commit('showOverlay',false);
            showError.value = true;
        }else{
            showError.value = false;
            response.data.forEach((res:IP_EQUIPAMENT)=>{
                allIPServer.value.push(res.ip??'');
            }); 
        }
    })
    .catch(function (error) {
        showConsoleError(error);
    }); 
}

onMounted(async()=>{
    await getIP();
    await getAllServerData();
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    color: "bgtopology",
    class: "defaultCard"
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('title.server')), 1),
      (showServer.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "ma-0 mt-5 pa-4",
            justify: "space-around"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrayServer.value, (item, i) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  class: "pa-0 my-3 text-center",
                  cols: "12",
                  sm: "12",
                  md: "6",
                  lg: "5",
                  xl: "4",
                  key: i
                }, {
                  default: _withCtx(() => [
                    _createVNode(LTECard, {
                      name: item.name,
                      sysuptime: item.uptime,
                      ip: item.ip,
                      arrayTable: item.dataTable,
                      statusElem: item.statusRow,
                      type: _unref(STRING_GENERAL).SERVER
                    }, null, 8, ["name", "sysuptime", "ip", "arrayTable", "statusElem", "type"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (showError.value)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 1,
            class: "ml-6 my-4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("h3", null, _toDisplayString(_unref(t)('noInformation')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})